
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import { Loader } from "../../utils/loader";
import { apiCall, initForgotPassword } from "../../services/authServices";

import {
  Error,
  LoginContain,
  LoginFooter,
  RequiredStar, 
} from "../../style/Login/Forgot";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Forgot() {
  const [credentials, setCredentials] = useState({
    adminId: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  // Validate the form
  const validateForm = () => {
    let formErrors = {};
    if (!credentials.adminId.trim())
      formErrors.adminId = "User ID is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Simulate form submission
  const submitEmail = async (e) => {
    try {
      e.preventDefault();
      if (validateForm()) {
        const payload = {
          adminId: credentials.adminId
        }
      //  const res = await apiCall({endpoint: 'api/auth/init-forgot-password', method: "POST", payload: payload})
      const res = await initForgotPassword(payload);
       if (res && res.success) {
        res['adminId'] = credentials.adminId;
        navigate("/forgotsend-otp", { state: { data: res } });
      }
      }
    } catch (error) {
      toast.error(error?.response?.data?.error ?? "Something went wrong");
    }
  };


  return (
    <>
      <ToastContainer />
      <LoginContain>
        <div className="LoginCard">
        <div className="LoginLogo">
          <img src={Logo} alt="logo"  loading="lazy"/>
        </div>
          <div className="LoginTitle">
            <h4>Forgot Password</h4>
            <p>Please forgot your password!</p>
          </div>
          <form onSubmit={submitEmail}>

            <div className="LoginGroup">
              <label htmlFor="adminId">
                Admin ID <RequiredStar>*</RequiredStar> {/* Corrected */}
              </label>
              <input
                type="text"
                id="userId"
                name="adminId"
                placeholder="Enter Your ID"
                value={credentials.adminId}
                onChange={handleChange}
              />
              {errors.adminId && <Error>{errors.adminId}</Error>}
            </div>
            <div className="LoginGroup LoginBtn">
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </LoginContain>
      <LoginFooter>
        <p>
          POWERED BY: <span>Manthan IT Solutions</span>
        </p>
      </LoginFooter>
    </>
  );
}

export default Forgot;